'use client'

import SvgIcon from '@mui/material/SvgIcon'
import PropTypes from 'prop-types'

export const PeopleIcon = ({ sx }) => {
  return (
    <SvgIcon sx={sx} data-testid="PeopleIcon">
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14" id="User-Multiple-Group--Streamline-Core">
        <g id="user-multiple-group--close-geometric-human-multiple">
          <path
            id="Subtract"
            fill="#5073c3"
            fillRule="evenodd"
            d="M11.1775 13H13.5c0.2761 0 0.5 -0.2239 0.5 -0.5V12c0 -2.76142 -2.2386 -5 -5.00004 -5 -0.08105 0 -0.16165 0.00193 -0.24176 0.00574C10.2716 8.14638 11.25 9.95893 11.25 12v0.5c0 0.1737 -0.0254 0.3416 -0.0725 0.5ZM7.97632 5.7815C8.28875 5.9219 8.63524 6 8.99996 6 10.3807 6 11.5 4.88071 11.5 3.5S10.3807 1 8.99996 1c-0.36472 0 -0.71121 0.0781 -1.02364 0.2185 0.48522 0.63205 0.77364 1.42309 0.77364 2.2815 0 0.85841 -0.28842 1.64945 -0.77364 2.2815Z"
            clipRule="evenodd"
            strokeWidth="1"
          ></path>
          <path
            id="Union"
            fill="#d7e0ff"
            fillRule="evenodd"
            d="M7.5 3.5C7.5 4.88071 6.38071 6 5 6S2.5 4.88071 2.5 3.5 3.61929 1 5 1s2.5 1.11929 2.5 2.5ZM0 12c0 -2.76142 2.23858 -5 5 -5s5 2.23858 5 5v0.5c0 0.2761 -0.22386 0.5 -0.5 0.5h-9c-0.276142 0 -0.5 -0.2239 -0.5 -0.5V12Z"
            clipRule="evenodd"
            strokeWidth="1"
          ></path>
        </g>
      </svg>
    </SvgIcon>
  )
}

PeopleIcon.propTypes = {
  sx: PropTypes.object
}
